export const TrfMixinInfiniteScroll = {
  data: {
    TrfMixInfiniteScroll: {
      page: 1,
      limit: 100,
      listagemCarregando: false,
      paginacaoFinalizada: false,
      distanciaParaPaginar: 50,
      carregarAteScroll: true,
    },
    TrfMixInfiniteScrollCustomConfig: {},
  },
  methods: {
    async TrfMixIncrementarPagina(page, limit) {
      console.warn(`Método "MXTrfIncrementarPagina" não foi implementado no componente. 
            É necessário um override deste método com suas requisições e tratamentos de paginação.`);
    },
    TrfMixIsPaginacaoNecessaria(el, customConfigName) {
      if (!!!el) return false;
      
      const hasCustomConfig = customConfigName && this.TrfMixInfiniteScrollCustomConfig[customConfigName]
      const customConfig = hasCustomConfig? this.TrfMixInfiniteScrollCustomConfig[customConfigName] : null;

      let isCarregando = this.TrfMixInfiniteScroll.listagemCarregando;
      let isFinalizada = this.TrfMixInfiniteScroll.paginacaoFinalizada;
      let distanciaPaginacao = this.TrfMixInfiniteScroll.distanciaParaPaginar;
      let carregarAteScroll = this.TrfMixInfiniteScroll.carregarAteScroll;

      if (hasCustomConfig && !this.isNullOrUndefined(customConfig.listagemCarregando)) {
        isCarregando = customConfig.listagemCarregando;
      }
      if (hasCustomConfig && !this.isNullOrUndefined(customConfig.paginacaoFinalizada)) {
        isFinalizada = customConfig.paginacaoFinalizada
      }
      if (hasCustomConfig && customConfig.distanciaParaPaginar) {
        distanciaPaginacao = customConfig.distanciaParaPaginar
      }
      if (hasCustomConfig && !this.isNullOrUndefined(customConfig.carregarAteScroll)) {
        carregarAteScroll = customConfig.carregarAteScroll
      }

      const distanciaParaPaginacao =
        el.scrollTop + el.clientHeight + distanciaPaginacao;
      if (isCarregando || isFinalizada) {
        return false;
      } else if (
        (el.scrollHeight <= el.clientHeight + distanciaPaginacao &&
          carregarAteScroll) ||
        el.scrollHeight <= distanciaParaPaginacao
      ) {
        return true;
      } else {
        return false;
      }
    },
    isScrollable(el) {
      if (!!!el) return false;
      const hasScrollableContent = el.scrollHeight > el.clientHeight;
      return hasScrollableContent;
    },
    isNullOrUndefined(value) {
      return typeof value === 'undefined' || value === null;
    },
    async realizarPaginacao(container, customConfigName) {
      if (!!!this.TrfMixIsPaginacaoNecessaria(container, customConfigName)) return;
      const hasCustomConfig = customConfigName && this.TrfMixInfiniteScrollCustomConfig[customConfigName];
      const customConfig = hasCustomConfig? this.TrfMixInfiniteScrollCustomConfig[customConfigName] : null;

      let page = this.TrfMixInfiniteScroll.page;
      let limit = this.TrfMixInfiniteScroll.limit;

      this.setCarregando(true, customConfigName);

      if (hasCustomConfig && customConfig.page) {
        page = customConfig.page;
      }
      if (hasCustomConfig && customConfig.limit) {
        limit = customConfig.limit;
      }

      if (hasCustomConfig && customConfig.incrementFn) {
        const incrementoListagem = await customConfig.incrementFn(
          page,
          limit
        );
      } else {
        const incrementoListagem = await this.TrfMixIncrementarPagina(
          page,
          limit
        );
      }

      this.setCarregando(false, customConfigName);
    },
    setCarregando(valor, customConfigName) {
      if (
        customConfigName &&
        this.TrfMixInfiniteScrollCustomConfig[customConfigName] &&
        !this.isNullOrUndefined(this.TrfMixInfiniteScrollCustomConfig[customConfigName])
      ) {
        this.TrfMixInfiniteScrollCustomConfig[customConfigName].listagemCarregando = valor;
      } else {
        this.TrfMixInfiniteScroll.listagemCarregando = valor;
      }
    },
    async TrfMixAderirAoInfiniteScroll(evento, customConfigName) {
      const html = document.querySelector("html");
      const container = evento.target == document ? html : evento.target;
      const paginar = await this.realizarPaginacao(container, customConfigName);
    },
  },
};
